import type {
  GetCustomerBalanceRequest,
  GetTransactionHistoryRequest,
  GetLoyaltyPolicyRequest,
  GetProductCreditPreviewRequest,
} from './types';

/** Cache identity for a signed-out visitor; distinct from any real customer id. */
const GUEST_IDENTITY = 'guest';

type PersonalisedKeyParams = { customerId?: string };
export type ProductCreditPreviewKeyParams = GetProductCreditPreviewRequest & PersonalisedKeyParams;

export const LOYALTY_QUERY_KEYS = {
  default: () => ['loyalty'] as const,
  getCustomerBalance: ({ customerId, currency }: GetCustomerBalanceRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'balance', customerId, currency] as const,
  getTransactionHistory: ({ customerId, limit, lastEvaluatedKey, currency, category }: GetTransactionHistoryRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'transactions', customerId, limit, lastEvaluatedKey, currency, category] as const,
  getLoyaltyPolicy: ({ currency }: GetLoyaltyPolicyRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'policy', currency] as const,
  /**
   * Personalised previews (the rate depends on who is signed in) carry the customer id as cache
   * identity so a guest entry can never be served after sign-in. It is not sent to the API,
   * which reads the session.
   */
  getProductCreditPreview: ({ productId, currency, customerId }: ProductCreditPreviewKeyParams) =>
    [
      ...LOYALTY_QUERY_KEYS.default(),
      'productCreditPreview',
      customerId ?? GUEST_IDENTITY,
      productId,
      currency,
    ] as const,
};
